import React from 'react'

export default function Deco4(props) {
  return (
    <svg width={51} height={51} viewBox="0 0 51 51" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.389 10.392l-.013.022c-4.26 5.077.518 16.1 10.672 24.62 10.153 8.52 21.838 11.31 26.098 6.234l.016-.013a23.89 23.89 0 01-10.192 7.138C21.514 52.927 7.742 46.505 3.208 34.05c-3.04-8.355-1.152-17.303 4.18-23.657z"
          fill="#57B560"
        />
        <path
          d="M33.97 48.393c12.455-4.533 18.877-18.305 14.344-30.76C43.78 5.176 30.008-1.246 17.553 3.287 5.097 7.822-1.325 21.594 3.208 34.05 7.742 46.505 21.514 52.927 33.97 48.393zm10.176-7.125c-4.26 5.077-15.945 2.285-26.098-6.235-10.154-8.52-14.932-19.542-10.672-24.62"
          stroke="#57B560"
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
